// extracted by mini-css-extract-plugin
export default {"inner":"Checkbox_inner__j2yop","label":"Checkbox_label__DEFUS"};